import React, { useEffect, useState } from "react";
import { AuthProvider } from "react-oidc-context";
import Layout from "./components/Layout";
import "./custom.css";
import { fetchConfigurationSettings } from "./utilities/orgPanelApiCalls";
import { WebStorageStateStore } from "oidc-client-ts";
import { setConfiguration } from "./utilities/appStore";
import Hotjar from "./components/Hotjar/hotjar";
import '@fortawesome/fontawesome-svg-core/styles.css';
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';

const App = () => {
    const [oidcConfig, setOidcConfig] = useState(null);
    const [useHotjar, setUseHotjar] = useState(false);
    const queryClient = new QueryClient()

    useEffect(() => {
        // Read config settings from Org Panel API, use to create AuthProvider
        fetchConfigurationSettings().then((configSettings) => {
            setConfiguration(configSettings);
            setUseHotjar(configSettings.useHotjar);

            setOidcConfig({
                authority: configSettings.authority,
                client_id: configSettings.clientId,
                redirect_uri: `${configSettings.rootUrl}signin-oidc`,
                post_logout_redirect_uri: `${configSettings.rootUrl}`,
                response_type: "code",
                scope: configSettings.scope,
                loadUserInfo: true,
                // Store auth cookie in localStorage rather than sessionStorage
                userStore: new WebStorageStateStore({ store: window.localStorage }),
            });
        });
    }, []);

    if (!oidcConfig) return <div>Loading configuration...</div>;

    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider {...oidcConfig}>           
                <Layout />
                {useHotjar && <Hotjar />}          
            </AuthProvider>
        </QueryClientProvider>
    );
};

export default App;